export default {
  methods: {
    buildPublicShareUrl() {
      const query = {
        dir: this.directoryId,
        preview: '1',
      };
      if (this.selectedDocId) {
        query.doc = this.selectedDocId;
      }
      const noClose = this.$route.query.noClose;
      if (noClose === '1' || noClose === 1 || noClose === 'true') {
        query.noClose = '1';
      }
      const qs = Object.keys(query)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
        .join('&');
      return `${window.location.origin}/tools/documents?${qs}`;
    },
    buildSingleDocumentShareUrl(docId) {
      const id = docId != null && docId !== '' ? docId : this.selectedDocId;
      if (id == null || id === '') return '';

      const query = {
        'document-id': String(id),
      };
      const noClose = this.$route.query.noClose;
      if (noClose === '1' || noClose === 1 || noClose === 'true') {
        query.noClose = '1';
      }
      const qs = Object.keys(query)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
        .join('&');
      return `${window.location.origin}/tools/document?${qs}`;
    },
    copyShareUrlToClipboard(shareUrl, successMessage) {
      if (!shareUrl) return;
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(shareUrl)
          .then(() => {
            this.$Message.success(successMessage);
          })
          .catch(() => {
            this.fallbackCopyShareUrl(shareUrl, successMessage);
          });
        return;
      }
      this.fallbackCopyShareUrl(shareUrl, successMessage);
    },
    copyPublicShareUrl() {
      const shareUrl = this.buildPublicShareUrl();
      this.copyShareUrlToClipboard(shareUrl, '已复制公开分享地址');
    },
    copySingleDocumentShareUrl() {
      if (!this.selectedDocId) {
        this.$Message.warning('请先选择文档');
        return;
      }
      const shareUrl = this.buildSingleDocumentShareUrl();
      this.copyShareUrlToClipboard(shareUrl, '已复制单文档分享地址');
    },
    fallbackCopyShareUrl(shareUrl, successMessage) {
      try {
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$Message.success(successMessage || '已复制分享地址');
      } catch (e) {
        window.prompt('请手动复制分享地址：', shareUrl);
      }
    },
  },
};
